import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 17.834 15.333"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, #B68559)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m1 3.5 6.464 4.763c.523.386.785.578 1.07.653.251.066.514.066.766 0 .284-.075.546-.267 1.07-.653L16.833 3.5M4.8 14.333h8.233c1.33 0 1.996 0 2.504-.272.446-.24.81-.622 1.037-1.093.26-.534.26-1.235.26-2.635V5c0-1.4 0-2.1-.26-2.635a2.44 2.44 0 0 0-1.037-1.093C15.029 1 14.363 1 13.033 1H4.8c-1.33 0-1.995 0-2.503.272-.447.24-.81.623-1.038 1.093C1 2.9 1 3.6 1 5v5.333c0 1.4 0 2.1.259 2.635.228.47.591.853 1.038 1.093.508.272 1.173.272 2.503.272"
    }, null, -1)
  ]))]))
}
export default { render: render }